var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsletter = function SvgNewsletter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3551_12555",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3551_12555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.01712 13.9584C2.56801 13.9584 2.18351 13.7985 1.86362 13.4786C1.54373 13.1587 1.38379 12.7742 1.38379 12.3251V1.94824L2.52179 3.04308L3.61546 1.94824L4.71562 3.04308L5.81596 1.94824L6.90962 3.04308L8.00046 1.94824L9.09129 3.04308L10.185 1.94824L11.2853 3.04308L12.3855 1.94824L13.4791 3.04308L14.6171 1.94824V12.3251C14.6171 12.7742 14.4572 13.1587 14.1373 13.4786C13.8174 13.7985 13.4329 13.9584 12.9838 13.9584H3.01712ZM3.01712 12.3251H7.25912V8.72508H3.01712V12.3251ZM8.74179 12.3251H12.9838V11.2757H8.74179V12.3251ZM8.74179 9.78374H12.9838V8.72508H8.74179V9.78374ZM3.01712 7.24241H12.9838V5.12508H3.01712V7.24241Z",
    fill: "currentColor"
  }))));
};
export default SvgNewsletter;